import { Helmet } from "react-helmet";

const SITE_URL = "https://bluewater-5c10e.web.app";
const SITE_NAME = "bywater的旅遊日記";

function HelmetWrapper({ title, description = "", image = "", path = "", children }) {
  const fullTitle = `${title} | ${SITE_NAME}`;
  const metaDescription = description || title;
  const canonicalUrl = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}/Img/country/Singapore/sgCityLine.jpeg`;

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:locale" content="zh_TW" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      {children}
    </>
  );
}

export default HelmetWrapper;
